{
  "avalancheSize.label": "Mesura de lauet",
  "avalancheSize.small": "Petit",
  "avalancheSize.medium": "Mejan",
  "avalancheSize.large": "Gran",
  "avalancheSize.very_large": "Molt gran",
  "avalancheSize.extreme": "Extremament gran",
  "snowpackStability.label": "Estabilitat deth celh de nhèu",
  "snowpackStability.good": "bona",
  "snowpackStability.fair": "regular",
  "snowpackStability.poor": "praube",
  "snowpackStability.very_poor": "molt praube",
  "frequency.label": "Frecuéncia",
  "frequency.none": "Cap",
  "frequency.few": "Pògui",
  "frequency.some": "Quauqui",
  "frequency.many": "Molti",
  "dangerRating.label": "Grad de perilh",
  "dangerRating.missing": "absent",
  "dangerRating.missing.long": "Absent",
  "dangerRating.no_snow": "sense nhèu",
  "dangerRating.no_snow.long": "Sense nhèu",
  "dangerRating.no_rating": "sense grad de perilh",
  "dangerRating.no_rating.long": "Sense grad de perilh",
  "dangerRating.low": "fèble",
  "dangerRating.low.long": "Grad de perilh 1 — Fèble",
  "dangerRating.low.speech": "perilh de lauegi fèble, per tant nivèu de perilh un",
  "dangerRating.moderate": "moderat",
  "dangerRating.moderate.long": "Grad de perilh 2 — Moderat",
  "dangerRating.moderate.speech": "perilh de lauegi moderat, per tant nivèu de perilh dus",
  "dangerRating.considerable": "Mercat",
  "dangerRating.considerable.long": "Grad de perilh 3 — Mercat",
  "dangerRating.considerable.speech": "perilh de lauegi mercat, per tant nivèu de perilh tres",
  "dangerRating.high": "fòrt",
  "dangerRating.high.long": "Grad de perilh 4 — Fort",
  "dangerRating.high.speech": "perilh de lauegi fòrt, per tant nivèu de perilh quate",
  "dangerRating.very_high": "plan fòrt",
  "dangerRating.very_high.long": "Grad de perilh 5 — Plan fort",
  "dangerRating.very_high.speech": "perilh de lauegi molt fòrt, per tant nivèu de perilh cinc",
  "avalancheType.label": "Tipe de lauet",
  "avalancheType.slab": "Lauet de placa",
  "avalancheType.loose": "Lauet sense coesion",
  "avalancheType.glide": "Lauet d'esguitlament basau",
  "avalancheProblem.label": "Problèma de lauegi",
  "avalancheProblem.coreZones.label": "Avalanche Problems with Core Zones",
  "avalancheProblem.new_snow": "Nhèu recenta",
  "avalancheProblem.wind_slab": "Placa de vent",
  "avalancheProblem.persistent_weak_layers": "Cocha fèble persistenta",
  "avalancheProblem.wet_snow": "Nhèu umida",
  "avalancheProblem.gliding_snow": "Esguitlament de nhèu",
  "avalancheProblem.favourable_situation": "Situacion favorabla",
  "avalancheProblem.cornices": "Cornises",
  "avalancheProblem.no_distinct_avalanche_problem": "Cap problèma de lauegi evident",
  "avalancheProblem.new_snow.speech": "un problema de nhèu recenta",
  "avalancheProblem.wind_slab.speech": "un problema de plaques de vent",
  "avalancheProblem.persistent_weak_layers.speech": "un problema de cocha fèbla persistenta",
  "avalancheProblem.wet_snow.speech": "un problema de nhèu umida",
  "avalancheProblem.gliding_snow.speech": "un problema d'esguitlaments basaus",
  "avalancheProblem.favourable_situation.speech": "ua situacion favorabla",
  "avalancheProblem.cornices.speech": "un problema de cornises",
  "avalancheProblem.no_distinct_avalanche_problem.speech": "cap problèma de lauegi evident",
  "dangerPattern.label": "Patrons de perilh",
  "dangerPattern.dp1": "pp.1: cocha fèbla persistena prigonda",
  "dangerPattern.dp2": "pp.2: esguitlament de nhèu",
  "dangerPattern.dp3": "pp.3: ploja",
  "dangerPattern.dp4": "pp.4: heired dessús de caud / caud dessús de heired",
  "dangerPattern.dp5": "pp.5: nheuada dempús d'un long periòde d'iuern",
  "dangerPattern.dp6": "pp.6: heired, nhèu sense coesion e vent",
  "dangerPattern.dp7": "pp.7: zònes praubes de nhèu en zònes abundantes de nhèu",
  "dangerPattern.dp8": "pp.8: geladiua de superfícia caperada damb nhèu",
  "dangerPattern.dp9": "pp.9: nhèu granulada caperada damb nhèu",
  "dangerPattern.dp10": "pp.10: scenari de primauera",
  "aspect.N": "Nòrd",
  "aspect.NE": "Nòrd-èst",
  "aspect.E": "Èst",
  "aspect.SE": "Sud-èst",
  "aspect.S": "Sud",
  "aspect.SW": "Sud-oèst",
  "aspect.W": "Oèst",
  "aspect.NW": "Nòrd-oèst",
  "tendency.label": "Tendéncia",
  "tendency.progression.label": "Development of avalanche danger",
  "tendency.decreasing": "Tendéncia: Diminucion deth perilh de lauegi",
  "tendency.steady": "Tendéncia: perilh de lauegi constant",
  "tendency.increasing": "Tendéncia: aument deth perilh de lauegi",
  "validTimePeriod.all_day": "tot eth dia",
  "validTimePeriod.all_day.long": "tot eth dia",
  "validTimePeriod.earlier": "mès lèu",
  "validTimePeriod.earlier.long": "mès lèu pendent eth dia",
  "validTimePeriod.later": "tard",
  "validTimePeriod.later.long": "mès tard pendent eth dia",
  "elevation.treeline.capitalized": "Limit deth bòsc",
  "elevation.treeline": "limit deth bòsc",
  "elevation.all": "Totes es còtes",
  "elevation.below": "Per dejós {0}",
  "elevation.above": "Per desssús {0}",
  "elevation.band": "Entre {0} e {1}",
  "synopsis.label": "Temps",
  "snowpack.label": "Celh de nhèu",
  "travelAdvisory.label": "Travel Advisory",
  "forecast.label": "Prediccion de lauegi"
}
